<template>
  <div
    class="pt-2 px-3 pb-2"
    :class="backgroundClass"
  >
    <div
      v-if="field.data.label && !noLabel"
      class="pt-1 mb-1"
    >
      <span class="field-label">{{ field.data.label }}</span>
    </div>
    <v-btn-toggle
      :value="textAlignmentButtonGroupIndex"
      mandatory
      class="elevation-0 overlay-options-field-bg"
    >
      <v-btn
        v-show="field.data.left == false ? false : true"
        flat
        color="black"
        :title="$t('textAlignmentLeft')"
        @click="onAlignmentChanged('LEFT')"
      >
        <v-icon>format_align_left</v-icon>
      </v-btn>
      <v-btn
        v-show="field.data.center == false ? false : true"
        flat
        color="black"
        :title="$t('textAlignmentCenter')"
        @click="onAlignmentChanged('CENTER')"
      >
        <v-icon>format_align_center</v-icon>
      </v-btn>
      <v-btn
        v-show="field.data.right == false ? false : true"
        flat
        color="black"
        :title="$t('textAlignmentRight')"
        @click="onAlignmentChanged('RIGHT')"
      >
        <v-icon>format_align_right</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import {OverlayOptionsField} from '@/mixins/overlayOptions.js';

export default {
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'overlay-options-field-bg',
    },
  },
  computed: {
    textAlignmentButtonGroupIndex() {
      if (this.value === 'LEFT') return 0;
      if (this.value === 'CENTER') return 1;
      if (this.value === 'RIGHT') return 2;
      return 0;
    },
  },
  methods: {
    onAlignmentChanged(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 12px;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.54);
}

.rotate-clear-icon-to-look >>> .v-input__icon--clear {
  transform: rotateZ(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataTextAlignmentField.vue